import React, { useState } from "react";
import { Modal } from "reactstrap";

export function FacturationConecs() {
    return <div>hiii</div>;
}

export default FacturationConecs;
